module.exports = __webpack_public_path__ + "product/added-quote-list-091e208c6406c7cf91bd83ab7b608190.svg";